// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, useTheme } from '@mui/system';
import stylesDef from './styles';
import { Button, Divider, Paper, Typography } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useEffect, useState } from 'react';
import { GetAllCustomBundlesThunk } from '../../bundle/bundleThunk';
import { useAppDispatch, useAppSelector } from 'Hooks';
import DeleteBundleDialog from './DeleteBundleDialog';
import CustomBundleItem from './CustomBundleItem';
import CreateCustomBundleDialog from './CreateCustomBundleDialog';
import { useParams } from 'react-router';
import { SetOrgIdAction } from 'Features/admin/adminActions';
import InfoIcon from '@mui/icons-material/Info';

const CustomBundles = () => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const dispatch = useAppDispatch();
  const _id = _ADMIN_ ? useParams().orgId: useAppSelector((state) => state.account.org._id);
  const { customBundles } = useAppSelector((state) => state.bundle);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [createCustomBundleDialogOpen, setCreateCustomBundleDialogOpen] = useState(false);
  const [selectedBundleId, setSelectedBundleId] = useState('');

  useEffect(() => {
    // If the user is an admin, set the orgId in the store
    // this is needed to load the header on page reload
    if (_ADMIN_) {
      dispatch(SetOrgIdAction(_id));
    }
    const fetchCustomBundles = async () => {
      await dispatch(GetAllCustomBundlesThunk(_id)); 
    }

    fetchCustomBundles();
  }, [])

  const handleOpenDeleteDialog = (bundleId:string) =>{
    setSelectedBundleId(bundleId)
    setDeleteDialogOpen(true)
  }

  const handleCreateNewBundle = () => {
    setCreateCustomBundleDialogOpen(true);
  }

  return (
    <Box sx={styles.contentWrapper}>
      <Box>
        <Box sx={styles.customBundleHeader}>
          <Box sx={styles.customBundlesTitleContainer}>
            <Typography variant='h3' sx={styles.customBundlesTitle}>Custom Bundles</Typography>
            <Box sx={styles.pricePerFootInfo}>
              <InfoIcon sx={styles.customBundleInfoIconColor} fontSize='small' />
              <Typography variant='body1' sx={styles.customBundleSubtitle}>
                Price per foot is estimated at a <span style={styles.customBundleSubtitle.header}>60 foot</span> buffer for a <span style={styles.customBundleSubtitle.header}>10 mile</span> project.
              </Typography>
            </Box>
          </Box>
          <Button
            variant='contained'
            color='primary'
            onClick={handleCreateNewBundle}
          >
            Create New Bundle
          </Button>
        </Box>
        <Divider sx={styles.divider} />
        <Paper elevation={1} sx={{...styles.paper, ...styles.customBundlesPaper}}>
          {customBundles.length > 0 ? (
            customBundles.map((bundle, index) => (
              <CustomBundleItem key={index} bundle={bundle} handleOpenDeleteDialog={handleOpenDeleteDialog}/>
            ))
          ) : (
            <>
              <FormatListBulletedIcon />
              <Typography variant='body1' sx={styles.noBundlesText}>
                Create a bundle of layers and deliverables you anticipate using frequently. Your custom bundles once created, can be viewed here.
              </Typography>
            </>
          )}
        </Paper>
      </Box>
      <CreateCustomBundleDialog open={createCustomBundleDialogOpen} setOpen={setCreateCustomBundleDialogOpen}/>
      <DeleteBundleDialog bundleId={selectedBundleId} setSelectedBundleId={setSelectedBundleId} open={deleteDialogOpen} setOpen={setDeleteDialogOpen}/>
    </Box>
  );
}

export default CustomBundles;
